import { RichTextField } from '@/components/RichTextField/RichTextField';
import { isRichTextEmpty } from '@/components/RichTextField/isRichTextEmpty';

export type CompanyValueDescriptionProps = {
  description?: string | null;
  className?: string;
  editorClassName?: string;
  'data-testid'?: string;
};

/**
 * Read-only TipTap rendering for company value descriptions (HTML or legacy plain text).
 */
export function CompanyValueDescription({
  description,
  className = '',
  editorClassName = 'min-h-0 p-0 text-sm',
  'data-testid': dataTestId = 'company-value-description',
}: CompanyValueDescriptionProps) {
  if (isRichTextEmpty(description)) {
    return null;
  }

  return (
    <div className={['company-value-description prose prose-sm max-w-none dark:prose-invert', className].join(' ')}>
      <RichTextField
        value={description ?? ''}
        onChange={() => undefined}
        disabled
        className="border-0 bg-transparent p-0 shadow-none"
        shellClassName="!mt-0 !mb-0 !rounded-none !border-0 !bg-transparent shadow-none dark:!bg-transparent"
        editorClassName={editorClassName}
        data-testid={dataTestId}
      />
    </div>
  );
}
